document.addEventListener('DOMContentLoaded', function() {
  var videoContainers = document.querySelectorAll('.video-container');

  // ── Shopify Video: Play (with sound) ──
  function playShopifyVideo(container) {
    var video = container.querySelector('.shopify-video');
    var thumbnail = container.querySelector('.video-thumbnail');
    var playIcon = container.querySelector('.play-icon');
    var muteToggle = container.querySelector('.mute-toggle');

    video.muted = false;
    thumbnail.style.opacity = '0';
    playIcon.style.display = 'none';
    video.style.opacity = '1';
    muteToggle.style.display = 'block';
    container.dataset.playing = 'true';

    // Show unmuted icon by default
    var mutedIcon = muteToggle.querySelector('.muted-icon');
    var unmutedIcon = muteToggle.querySelector('.unmuted-icon');
    if (mutedIcon) mutedIcon.style.display = 'none';
    if (unmutedIcon) unmutedIcon.style.display = 'block';

    video.play().catch(function(error) {
      console.error('Error playing video:', error);
      pauseShopifyVideo(container);
    });
  }

  // ── Shopify Video: Pause ──
  function pauseShopifyVideo(container) {
    var video = container.querySelector('.shopify-video');
    var thumbnail = container.querySelector('.video-thumbnail');
    var playIcon = container.querySelector('.play-icon');
    var muteToggle = container.querySelector('.mute-toggle');

    video.pause();
    thumbnail.style.opacity = '1';
    playIcon.style.display = 'flex';
    video.style.opacity = '0';
    muteToggle.style.display = 'none';
    container.dataset.playing = 'false';
  }

  // ── Shopify Video: Toggle (user click) ──
  function toggleShopifyVideo(container) {
    if (container.dataset.playing === 'true') {
      pauseShopifyVideo(container);
    } else {
      playShopifyVideo(container);
    }
  }

  // ── YouTube: Load ──
  function loadYouTubeVideo(container, shouldPlay) {
    var videoId = container.dataset.videoId;
    var videoAspect = container.dataset.videoAspect || 'vertical';
    var iframeContainer = container.querySelector('.video-iframe-container');
    var thumbnail = container.querySelector('.video-thumbnail');
    var playIcon = container.querySelector('.play-icon');
    var muteToggle = container.querySelector('.mute-toggle');

    var iframe = document.createElement('iframe');
    iframe.className = 'video-iframe';
    iframe.loading = 'lazy';

    var videoSrc = 'https://www.youtube.com/embed/' + videoId +
      '?enablejsapi=1&autoplay=' + (shouldPlay ? '1' : '0') +
      '&mute=0&showinfo=0&modestbranding=1&controls=0&playsinline=1&rel=0&loop=1&playlist=' + videoId;
    if (videoAspect === 'vertical') {
      videoSrc += '&orientation=portrait';
    }

    iframe.src = videoSrc;
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    iframeContainer.appendChild(iframe);

    if (shouldPlay) {
      thumbnail.style.opacity = '0';
      playIcon.style.display = 'none';
      iframe.style.opacity = '1';
      muteToggle.style.display = 'block';
      container.dataset.playing = 'true';

      // Show unmuted icon
      var mutedIcon = muteToggle.querySelector('.muted-icon');
      var unmutedIcon = muteToggle.querySelector('.unmuted-icon');
      if (mutedIcon) mutedIcon.style.display = 'none';
      if (unmutedIcon) unmutedIcon.style.display = 'block';
    }

    // Mute toggle for YouTube
    muteToggle.addEventListener('click', function() {
      var mutedIcon = muteToggle.querySelector('.muted-icon');
      var unmutedIcon = muteToggle.querySelector('.unmuted-icon');
      var isMuted = mutedIcon.style.display !== 'none';

      if (isMuted) {
        mutedIcon.style.display = 'none';
        unmutedIcon.style.display = 'block';
        iframe.contentWindow && iframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
      } else {
        mutedIcon.style.display = 'block';
        unmutedIcon.style.display = 'none';
        iframe.contentWindow && iframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
      }
    });
  }

  // ── YouTube: Play ──
  function playYouTubeVideo(container) {
    var iframe = container.querySelector('iframe');
    var thumbnail = container.querySelector('.video-thumbnail');
    var playIcon = container.querySelector('.play-icon');
    var muteToggle = container.querySelector('.mute-toggle');

    thumbnail.style.opacity = '0';
    playIcon.style.display = 'none';
    iframe.style.opacity = '1';
    muteToggle.style.display = 'block';
    container.dataset.playing = 'true';

    if (iframe.contentWindow) {
      iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    }
  }

  // ── YouTube: Pause ──
  function pauseYouTubeVideo(container) {
    var iframe = container.querySelector('iframe');
    var thumbnail = container.querySelector('.video-thumbnail');
    var playIcon = container.querySelector('.play-icon');
    var muteToggle = container.querySelector('.mute-toggle');

    thumbnail.style.opacity = '1';
    playIcon.style.display = 'flex';
    iframe.style.opacity = '0';
    muteToggle.style.display = 'none';
    container.dataset.playing = 'false';

    if (iframe.contentWindow) {
      iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }
  }

  // ── YouTube: Toggle (user click) ──
  function toggleYouTubePlayPause(container) {
    if (container.dataset.playing === 'true') {
      pauseYouTubeVideo(container);
    } else {
      var iframe = container.querySelector('iframe');
      if (iframe) {
        playYouTubeVideo(container);
      } else {
        loadYouTubeVideo(container, true);
      }
    }
  }

  // ── Set up each container (no autoplay, no observer) ──
  videoContainers.forEach(function(container) {
    var videoSource = container.dataset.videoSource;
    var playIcon = container.querySelector('.play-icon');

    // Initialize state — all videos start paused with thumbnail showing
    container.dataset.playing = 'false';

    // Play icon click — toggle play/pause
    playIcon.addEventListener('click', function(e) {
      e.stopPropagation();
      if (videoSource === 'youtube') {
        toggleYouTubePlayPause(container);
      } else if (videoSource === 'shopify') {
        toggleShopifyVideo(container);
      }
    });

    // Shopify video: click the video itself to pause/play
    if (videoSource === 'shopify') {
      var video = container.querySelector('.shopify-video');
      var muteToggle = container.querySelector('.mute-toggle');

      video.addEventListener('click', function(e) {
        e.stopPropagation();
        toggleShopifyVideo(container);
      });

      // Mute toggle for Shopify videos
      muteToggle.addEventListener('click', function(e) {
        e.stopPropagation();
        var mutedIcon = muteToggle.querySelector('.muted-icon');
        var unmutedIcon = muteToggle.querySelector('.unmuted-icon');
        var isMuted = video.muted;

        video.muted = !isMuted;

        if (isMuted) {
          mutedIcon.style.display = 'none';
          unmutedIcon.style.display = 'block';
        } else {
          mutedIcon.style.display = 'block';
          unmutedIcon.style.display = 'none';
        }
      });
    }

    // YouTube iframe container: click to pause/play
    if (videoSource === 'youtube') {
      var iframeContainer = container.querySelector('.video-iframe-container');
      iframeContainer.addEventListener('click', function(e) {
        e.stopPropagation();
        toggleYouTubePlayPause(container);
      });
    }
  });
});
